import { render } from "./AddressDataForm.vue?vue&type=template&id=4226c8f5"
import script from "./AddressDataForm.vue?vue&type=script&lang=js"
export * from "./AddressDataForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__